import { IconProps } from "../../utils/global-types/global-types";

const MentionsIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-5 h-5"}
      {...rest}
    >
      <g fill="currentColor" clipPath="url(#clip0_4208_73151)">
        <path d="M9.03 7.652a1.32 1.32 0 0 0-1.32 1.319 1.32 1.32 0 0 0 1.32 1.318 1.32 1.32 0 0 0 1.318-1.318 1.32 1.32 0 0 0-1.319-1.319"></path>
        <path d="M8.97 1.5C4.852 1.5 1.5 4.851 1.5 8.97c0 4.12 3.351 7.53 7.47 7.53 4.12 0 7.53-3.41 7.53-7.53 0-4.119-3.41-7.47-7.53-7.47m3.135 9.668a1.75 1.75 0 0 1-1.436-.75c-.402.456-.985.75-1.64.75a2.2 2.2 0 0 1-2.197-2.197 2.2 2.2 0 0 1 2.197-2.198c.497 0 .95.172 1.319.451v-.011a.44.44 0 1 1 .879 0V9.41a.88.88 0 0 0 1.757 0c0-2.941-1.946-4.394-3.955-4.394A3.96 3.96 0 0 0 5.074 8.97a3.96 3.96 0 0 0 3.955 3.955c.88 0 1.71-.282 2.404-.815.464-.354.995.345.536.697a4.8 4.8 0 0 1-2.94.997A4.84 4.84 0 0 1 4.195 8.97 4.84 4.84 0 0 1 9.03 4.137c2.429 0 4.834 1.79 4.834 5.273a1.76 1.76 0 0 1-1.758 1.758"></path>
      </g>
      <defs>
        <clipPath id="clip0_4208_73151">
          <path fill="#fff" d="M1.5 1.5h15v15h-15z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default MentionsIcon;
